export default {
    'COMPANY.EDIT.TITLE': 'Modifier votre compte',
};
